import { BrowserRouter, HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { PersonnelManagementPage } from './pages/PersonnelManagementPage';
import { PersonnelDetailPage } from './pages/PersonnelDetailPage';
import { PersonalProfilePage } from './pages/PersonalProfilePage';
import { UpdatePersonalProfilePage } from './pages/UpdatePersonalProfilePage';
import { UpdatePersonalInfoPage } from './pages/UpdatePersonalInfoPage';
import { EditHistoryDetailPage } from './pages/EditHistoryDetailPage';
import { DepartmentManagementPage } from './pages/DepartmentManagementPage';
import { TimekeepingManagementPage } from './pages/TimekeepingManagementPage';
import { TimesheetTablePage } from './pages/TimesheetTablePage';
import { SystemSettingsPage } from './pages/SystemSettingsPage';
import { ActivityLogsPage } from './pages/ActivityLogsPage';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { OTPVerificationPage } from './pages/OTPVerificationPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { AvatarProvider } from './contexts/AvatarContext';

function AppRoutes() {
  return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/otp-verification" element={<OTPVerificationPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        {/* Trang tổng quan dành cho nhân viên (staff) */}
        <Route
          path="/personal/overview"
          element={
            <ProtectedRoute>
              <AppLayout>
                <HomePage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/personal/profile"
          element={
            <ProtectedRoute>
              <AppLayout>
                <PersonalProfilePage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/personal/profile/update"
          element={
            <ProtectedRoute>
              <AppLayout>
                <UpdatePersonalProfilePage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Navigate to="/personal/profile" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/management/timekeeping"
          element={
            <ProtectedRoute allowedRoles={['admin', 'ceo', 'hr']}>
              <AppLayout>
                <TimekeepingManagementPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/management/salary/timesheet-table"
          element={
            <ProtectedRoute allowedRoles={['admin', 'ceo', 'hr']}>
              <AppLayout>
                <TimesheetTablePage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/management/personnel"
          element={
            <ProtectedRoute allowedRoles={['admin', 'ceo', 'hr']}>
              <AppLayout>
                <PersonnelManagementPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/management/personnel/detail/:employeeCode"
          element={
            <ProtectedRoute>
              <AppLayout>
                <PersonnelDetailPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/management/personnel/update-personal-info"
          element={
            <ProtectedRoute>
              <AppLayout>
                <UpdatePersonalInfoPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/management/personnel/edit-history/:version"
          element={
            <ProtectedRoute>
              <AppLayout>
                <EditHistoryDetailPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/management/department"
          element={
            <ProtectedRoute allowedRoles={['admin', 'ceo', 'hr']}>
              <AppLayout>
                <DepartmentManagementPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/management/settings"
          element={
            <ProtectedRoute allowedRoles={['admin', 'ceo', 'hr']}>
              <AppLayout>
                <SystemSettingsPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/management/activity-logs"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AppLayout>
                <ActivityLogsPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/test"
          element={
            <div style={{ padding: 24 }}>
              <h1>Test Page - Nếu thấy trang này thì routing OK</h1>
            </div>
          }
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AppLayout>
                <HomePage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
  );
}

function App() {
  const Router = window.location.protocol === 'file:' ? HashRouter : BrowserRouter;

  return (
    <AuthProvider>
      <AvatarProvider>
        <SocketProvider>
          <Router>
            <AppRoutes />
          </Router>
        </SocketProvider>
      </AvatarProvider>
    </AuthProvider>
  );
}

export default App;
